/* FFL Scroll Reveal v1.0 — Ring Upgrade Page animations */
(function () {
  'use strict';

  // Only run on the ring upgrade page
  if (!document.body.classList.contains('template-page') &&
      !window.location.pathname.includes('ring-upgrade')) return;

  function initScrollReveal() {
    // Targets: section headings, cards, stat boxes, trust items, step cards
    var selectors = [
      // Hero section
      '[class*="ai-bespoke-studio__left-"]',
      // Trust badges
      '[class*="ai-trust-badge-item-"]',
      // Process steps
      '[class*="ai-process-step-"]:not([class*="number"]):not([class*="icon"]):not([class*="title"]):not([class*="desc"])',
      // Form section
      '.rup-trust__stat',
      '.rup-trust__item',
      '.rup-trust__review',
      '.rup-form-wrap',
      '.rup-connect-wrap',
      // Story cards
      '[class*="ai-ring-upgrade-story__card-"]',
      // Pricing columns
      '[class*="ai-pricing-comparison-column-"]',
      // What sets us apart cards
      '[class*="ai-what-sets-us-apart-card-"]',
      // Reviews panel
      '[class*="ai-reviews-left-panel-"]',
      '[class*="ai-reviews-right-panel-"]',
      // FAQ items
      '[class*="ai-faq-accordion__item-"]',
      // Section headings
      '[class*="ai-process-header-"]',
      '[class*="ai-ring-upgrade-story__header-"]',
      '[class*="ai-pricing-comparison-header-"]',
      '[class*="ai-what-sets-us-apart-header-"]',
      '[class*="ai-reviews-heading-"]',
      '[class*="ai-faq-accordion__header-"]',
      '[class*="ai-comparison-top-"]',
      '[class*="ai-gradient-banner__container-"]'
    ];

    var allEls = [];
    selectors.forEach(function (sel) {
      try {
        var els = document.querySelectorAll(sel);
        els.forEach(function (el) {
          if (!el.hasAttribute('data-ffl-observed')) {
            allEls.push(el);
          }
        });
      } catch (e) {}
    });

    if (!allEls.length) return;

    // Add base animation class
    allEls.forEach(function (el, i) {
      el.setAttribute('data-ffl-observed', '1');
      el.classList.add('ffl-animate');
      // Stagger siblings (cards in same grid)
      var parent = el.parentElement;
      if (parent) {
        var siblings = parent.querySelectorAll('[data-ffl-observed]');
        var idx = Array.prototype.indexOf.call(siblings, el);
        if (idx > 0 && idx <= 3) {
          el.classList.add('ffl-delay-' + idx);
        }
      }
    });

    // Use IntersectionObserver
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ffl-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    allEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }

  // Re-run after short delay to catch dynamically rendered blocks
  setTimeout(initScrollReveal, 800);
  setTimeout(initScrollReveal, 2000);

})();
